import Link from "@/components/Link";
import {
  FacebookIcon,
  GinnedBlogIcon,
  InstagramIcon,
  LinkedInIcon,
  PinterestIcon,
  TiktokIcon,
  TwitterIcon,
  YoutubeIcon,
} from "@/components/ui/icons/SocialIcons";
import { clsx } from "@cgc/ui/utils/clsx";
import React from "react";

export type SocialsListProps = {
  className?: string;
  tiktok?: string;
  facebook?: string;
  instagram?: string;
  pinterest?: string;
  twitter?: string;
  youtube?: string;
  ginned_blog?: string;
  linkedin?: string;
  size?: number;
};

const SocialsList: React.FC<SocialsListProps> = ({
  className,
  tiktok,
  facebook,
  instagram,
  pinterest,
  twitter,
  youtube,
  ginned_blog,
  linkedin,
  size,
}) => (
  <div className={clsx("grid grid-flow-col justify-center gap-4", className)}>
    {tiktok && (
      <Link href={tiktok}>
        <TiktokIcon size={size} />
      </Link>
    )}
    {facebook && (
      <Link href={facebook}>
        <FacebookIcon size={size} />
      </Link>
    )}
    {instagram && (
      <Link href={instagram}>
        <InstagramIcon size={size} />
      </Link>
    )}
    {pinterest && (
      <Link href={pinterest}>
        <PinterestIcon size={size} />
      </Link>
    )}
    {twitter && (
      <Link href={twitter}>
        <TwitterIcon size={size} />
      </Link>
    )}
    {youtube && (
      <Link href={youtube}>
        <YoutubeIcon size={size} />
      </Link>
    )}
    {ginned_blog && (
      <Link href={ginned_blog}>
        <GinnedBlogIcon size={size} />
      </Link>
    )}
    {linkedin && (
      <Link href={linkedin}>
        <LinkedInIcon size={size} />
      </Link>
    )}
  </div>
);

export default SocialsList;
